import {mountProgress} from "../learn/progress"
import {mount as domainChecker} from "../learn/domain_checker"
import {mount as spfBuilder} from "../learn/spf_builder"
import {mount as dmarcDial} from "../learn/dmarc_dial"
import {mount as warmupSimulator} from "../learn/warmup_simulator"
import {mount as warmupPlanner} from "../learn/warmup_planner"
import {mount as poolPlanner} from "../learn/pool_planner"
import {mount as setupChecklist} from "../learn/setup_checklist"
import {mount as quiz} from "../learn/quiz"
import {mount as mailSorter} from "../learn/mail_sorter"
import {mount as unsubscribeJudge} from "../learn/unsubscribe_judge"
import {mount as subdomainPlanner} from "../learn/subdomain_planner"
import {mount as reputationMeter} from "../learn/reputation_meter"
import {mount as bounceDecoder} from "../learn/bounce_decoder"
import {mount as inboundRouter} from "../learn/inbound_router"

const WIDGETS = {
  domain_checker: domainChecker,
  spf_builder: spfBuilder,
  dmarc_dial: dmarcDial,
  warmup_simulator: warmupSimulator,
  warmup_planner: warmupPlanner,
  pool_planner: poolPlanner,
  setup_checklist: setupChecklist,
  quiz,
  mail_sorter: mailSorter,
  unsubscribe_judge: unsubscribeJudge,
  subdomain_planner: subdomainPlanner,
  reputation_meter: reputationMeter,
  bounce_decoder: bounceDecoder,
  inbound_router: inboundRouter
}

function mountAll(scope) {
  const root = scope || document
  mountProgress(root)
  root.querySelectorAll("[data-learn-widget]").forEach((el) => {
    if (el.dataset.learnBound === "true") return
    const mount = WIDGETS[el.dataset.learnWidget]
    if (!mount) return
    el.dataset.learnBound = "true"
    mount(el)
  })
}

function start() {
  if (window.postshibaLearn) return
  window.postshibaLearn = true
  document.addEventListener("DOMContentLoaded", () => mountAll())
  document.addEventListener("turbo:load", () => mountAll())
  if (document.readyState !== "loading") mountAll()
}

start()
